import React from "react";
import DashboardCard from "../dashboard/DashboardCard";
import DashboardUpcomingTrip from "../dashboard/DashboardUpcomingTrip";
import { getWidgetIcon } from "../../config/widgetIconRegistry";
import { useUser } from "../../pages/login/UserContextPersistent";

function renderDashboardTitle(section, t) {
  const labelKey = section?.props?.labelKey || "dashboard";
  return <span className="dashboard-title">{t(labelKey)}</span>;
}

function hasPermission(userFeatures, requiredPermission) {
  if (!requiredPermission || !requiredPermission.apiPath) return true;
  if (!Array.isArray(userFeatures) || userFeatures.length === 0) return true;
  return userFeatures.some((feature) => {
    const pathMatches = feature.api_path?.includes(requiredPermission.apiPath);
    if (!pathMatches) return false;
    if (!requiredPermission.action) return true;
    return feature.action === requiredPermission.action;
  });
}

function renderMetricGrid(section, { metrics, t, userFeatures, organizationInactive }) {
  const widgets = Array.isArray(section?.widgets) ? section.widgets : [];

  const visibleCards = widgets.filter((widget) => hasPermission(userFeatures, widget.permission));

  if (visibleCards.length === 0) {
    return (
      <div className="no-permissions-state">
        <p>{t("noDataFound")}</p>
      </div>
    );
  }

  return (
    <div className={`dashboard-grid-container${organizationInactive ? " dashboard-grid-container--full" : ""}`}>
      {visibleCards.map((widget) => {
        const number = metrics[widget.metricKey];
        const extraInfo = Array.isArray(widget.subMetrics)
          ? widget.subMetrics.map((subMetric) => ({
              icon: getWidgetIcon(subMetric.icon, subMetric.labelKey),
              number: metrics[subMetric.metricKey],
              title: t(subMetric.labelKey),
              label: t(subMetric.labelKey),
            }))
          : [];

        return (
          <DashboardCard
            key={widget.id}
            title={t(widget.labelKey)}
            number={typeof number === "undefined" ? "--" : number}
            icon={getWidgetIcon(widget.icon, widget.labelKey)}
            extraInfo={extraInfo}
            path={widget.navigateTo}
          />
        );
      })}
    </div>
  );
}

export default function PageLayoutRenderer({ layout, metrics, t, userFeatures }) {
  const { organizationInactive } = useUser();
  const sections = Array.isArray(layout?.sections) ? layout.sections : [];
  const titleSection = sections.find((section) => section.type === "dashboardTitle");
  const metricGridSection = sections.find((section) => section.type === "metricGrid");
  const upcomingTripSection = sections.find((section) => section.type === "upcomingTrip");

  return (
    <>
      {titleSection ? renderDashboardTitle(titleSection, t) : null}
      <div className="row">
        {metricGridSection ? renderMetricGrid(metricGridSection, { metrics, t, userFeatures, organizationInactive }) : null}
        {upcomingTripSection && !organizationInactive ? (
          <div className="dashboard-upcoming-section">
            <DashboardUpcomingTrip />
          </div>
        ) : null}
      </div>
    </>
  );
}
